import { render, staticRenderFns } from "./Partner-login.vue?vue&type=template&id=2a868ede&scoped=true&"
import script from "./Partner-login.vue?vue&type=script&lang=js&"
export * from "./Partner-login.vue?vue&type=script&lang=js&"
import style0 from "./Partner-login.vue?vue&type=style&index=0&id=2a868ede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a868ede",
  null
  
)

component.options.__file = "Partner-login.vue"
export default component.exports